var _a;
export const USE_FEDERATION = process.env.USE_FEDERATION === 'true';
export const FEDERATION_API_HOST = (_a = process.env.FEDERATION_API_HOST) !== null && _a !== void 0 ? _a : '';
